import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();

export const demoMode = import.meta.env.VITE_DEMO_MODE === "true";
export const hasSupabaseConfig = Boolean(url && publishableKey);

export const supabase = hasSupabaseConfig
  ? createClient(url, publishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
